import React, { useState } from "react";
import { Upload, Send, Check } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export const ArtShowRequest = () => {
  const { token } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ full_name: "", email: "", bio: "", links: "", location: "", upload_url: "" });
  const [state, setState] = useState("idle");
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await fetch(`${API}/api/uploads`, {
        method: "POST",
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
      const data = await res.json();
      if (res.ok && data.url) setForm((f) => ({ ...f, upload_url: data.url }));
    } catch { /* leave empty */ }
    setUploading(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try {
      const res = await fetch(`${API}/api/artshow-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setState(res.ok ? "ok" : "error");
    } catch {
      setState("error");
    }
  };

  return (
    <section className="music-requests" data-testid="artshow-request">
      <button className="btn-ghost" onClick={() => setOpen(!open)} data-testid="artshow-toggle">
        <Upload size={16} /> Submit work for the Art Show
      </button>
      {open && (
        <form className="req-form" onSubmit={submit} data-testid="artshow-form">
          <h3 className="req-title">Upload work for the art show</h3>
          <div className="req-grid">
            <label className="req-field"><span className="req-label">Full name*</span>
              <input className="req-input" required value={form.full_name} data-testid="artshow-name"
                onChange={(e) => setForm({ ...form, full_name: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Email*</span>
              <input className="req-input" type="email" required value={form.email} data-testid="artshow-email"
                onChange={(e) => setForm({ ...form, email: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Location*</span>
              <input className="req-input" required value={form.location} data-testid="artshow-location"
                onChange={(e) => setForm({ ...form, location: e.target.value })} /></label>
            <label className="req-field"><span className="req-label">Website & social links</span>
              <input className="req-input" value={form.links} data-testid="artshow-links"
                onChange={(e) => setForm({ ...form, links: e.target.value })} placeholder="site, IG, etc." /></label>
          </div>
          <label className="req-field"><span className="req-label">Short bio*</span>
            <textarea className="req-input" rows={3} required value={form.bio} data-testid="artshow-bio"
              onChange={(e) => setForm({ ...form, bio: e.target.value })} /></label>
          <label className="req-field"><span className="req-label">Upload your work {token ? "" : "(log in to upload, or drop a link above)"}</span>
            <input className="req-input" type="file" accept="image/*,video/*" disabled={!token || uploading}
              data-testid="artshow-file" onChange={(e) => uploadFile(e.target.files?.[0])} /></label>
          {uploading && <div className="shirt-member-note">Uploading…</div>}
          {form.upload_url && <div className="shirt-member-note" data-testid="artshow-uploaded">✓ Work attached</div>}
          {state === "ok" ? (
            <div className="shirt-claim-ok" data-testid="artshow-ok"><Check size={16} /> Submitted — we'll be in touch.</div>
          ) : (
            <button className="btn-solid" type="submit" disabled={state === "busy"} data-testid="artshow-submit">
              <Send size={15} /> {state === "busy" ? "Sending…" : "Submit"}
            </button>
          )}
          {state === "error" && <div className="cart-error">Couldn't submit — check the fields and try again.</div>}
        </form>
      )}
    </section>
  );
};
